/*
 * Public API Surface of product-promotions-data
 */

export * from './lib';
